import { initializeAppSettings } from "@next-platform/client-common-core";
import basicAppConfig from "@next-platform/client-common-core/infra/constants/basicAppConfig";

import initializeLocalization from "@/config/initializeLocalization";
import { persistAffiliateFromUrl } from "@/features/attribution/persistAffiliateFromUrl";

// TODO(Ankush): [NX-12168] Make intialize app cross platform.
const initializeApp = (): void => {
  persistAffiliateFromUrl();

  const appId = basicAppConfig.applicationId;
  void initializeLocalization({ appId });
  initializeAppSettings({ appId });
};

export default initializeApp;
